<template>
  <div class="my-class">
    <classShow v-for="(data,i) in msgs" :key="i" :msg="data" />
    <div class="my-class-posi" @click="goAssessment()">
      <span class="el-icon-document">学习评估</span>
    </div>
  </div>
</template>
<script>
import classShow from "@/views/component/classShow";
export default {
  data() {
    return {
      msgs: []
    };
  },
  mounted() {
    this.getMsg();
  },
  methods: {
    goAssessment() {
      this.$router.push({
        path: "/study/assessment",
        query: {
          title: "学习评估"
        }
      });
    },
    getMsg() {
      this.axios
        .get(
          `/api/Index/GetMyStudyClass?userid=${sessionStorage.getItem("id")}`
        )
        .then(e => {
          if (e.data.code == 0) {
            console.log(e.data);
            this.msgs = e.data.msg
          }
        });
      
    }
  },
  components: {
    classShow
  }
};
</script>
<style lang='scss' scoped>
.my-class {
  &-posi {
    color: #ffb849;
    position: absolute;
    top: 0.25rem;
    right: 0.2rem;
    z-index: 11;
  }
  .class-show:not(:nth-child(1)) {
    margin-top: 0.4rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>